/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    iconPosition: {
      description: 'Theme styles to be applied to icon links depending on where the icon is in relation to the link text',
      type: 'state',
      values: [ 'left', 'right', 'inline' ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    },
    size: { type: 'variant', values: [ 'small' ] },
    style: {
      description: 'Configure `style` variant for `ButtonGroupItem`',
      type: 'variant',
      values: [ 'contained' ]
    },
    width: {
      description: 'Available in default, responsive or equal. Default-width expands based on content. Responsive automatically applies full-width when is displayed on the XS viewport, equal divide the available width equally among `ButtonGroup`',
      type: 'variant',
      values: [ 'responsive', 'equal' ]
    }
  },
  rules: [
    { if: { width: 'equal' }, tokens: { width: '100%' } },
    {
      if: { size: 'small' },
      tokens: { height: 32, paddingBottom: 4, paddingTop: 4 }
    },
    { if: { hover: true }, tokens: { borderWidth: 3 } },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#676e73',
        borderColor: '#676e73',
        color: '#ffffff'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#676e73',
        borderColor: '#676e73',
        borderWidth: 0,
        color: '#ffffff'
      }
    },
    {
      if: { focus: true },
      tokens: {
        borderColor: '#676e73',
        outerBorderColor: '#676e73',
        outerBorderGap: 2,
        outerBorderWidth: 2
      }
    },
    { if: { hover: true }, tokens: { borderWidth: 3 } },
    {
      if: { selected: true },
      tokens: { backgroundColor: '#4b286d', borderWidth: 0, color: '#ffffff' }
    },
    {
      if: { hover: true, selected: true },
      tokens: { backgroundColor: '#7c53a5' }
    },
    {
      if: { pressed: true, selected: true },
      tokens: { backgroundColor: '#3f2a54' }
    },
    {
      if: { focus: true, selected: true },
      tokens: { outerBorderColor: '#4b286d' }
    },
    {
      if: { focus: true, pressed: true, selected: true },
      tokens: { outerBorderColor: '#3f2a54' }
    },
    {
      if: { inactive: true },
      tokens: { backgroundColor: '#b2b9bf', borderWidth: 0, color: '#ffffff' }
    },
    { if: { iconPosition: 'right' }, tokens: { iconSpace: 1 } },
    { if: { width: 'responsive' }, tokens: { width: '100%' } },
    {
      if: { style: 'contained' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0,
        height: 40,
        paddingBottom: 8,
        paddingTop: 8
      }
    },
    {
      if: { size: 'small', style: 'contained' },
      tokens: { height: 32, paddingBottom: 6, paddingTop: 6 }
    },
    {
      if: { hover: true, style: 'contained' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#676e73',
        borderWidth: 3
      }
    },
    {
      if: { selected: true, style: 'contained' },
      tokens: {
        backgroundColor: '#4b286d',
        color: '#ffffff',
        outerBorderWidth: 0
      }
    },
    {
      if: { focus: true, style: 'contained' },
      tokens: { borderColor: '#676e73', borderWidth: 1, outerBorderWidth: 0 }
    },
    {
      if: { hover: true, selected: true, style: 'contained' },
      tokens: {
        backgroundColor: '#7c53a5',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#ffffff',
        outerBorderWidth: 0
      }
    },
    {
      if: { focus: true, selected: true, style: 'contained' },
      tokens: { outerBorderColor: '#4b286d', outerBorderWidth: 2 }
    },
    {
      if: { pressed: true, style: 'contained' },
      tokens: { backgroundColor: '#3f2a54' }
    }
  ],
  tokens: {
    alignSelf: 'flex-start',
    backgroundColor: '#ffffff',
    borderColor: '#b2b9bf',
    borderRadius: 32,
    borderWidth: 1,
    color: '#676e73',
    fontName: 'HNforTELUSSA',
    fontSize: 14,
    fontWeight: '700',
    height: 48,
    iconSize: 20,
    iconSpace: 2,
    lineHeight: 1.42857142857,
    minWidth: 0,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 2,
    outerBorderWidth: 2,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    shadow: null,
    textAlign: 'center',
    width: null
  }
}
export default theme
